import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './SeeAllSlide.scss';
var SeeAllSlide = function (_a) {
    var title = _a.title, style = _a.style, seeAllUrl = _a.seeAllUrl, ButtonComponent = _a.component, containerClassName = _a.containerClassName, props = __rest(_a, ["title", "style", "seeAllUrl", "component", "containerClassName"]);
    var t = useTranslation().t;
    var contex = (React.createElement("div", { className: classnames(s['see-all-slide'], containerClassName), style: style },
        React.createElement("span", null, title || t('common.see_all'))));
    return ButtonComponent ? (React.createElement(ButtonComponent, __assign({}, props), contex)) : (React.createElement("a", { href: seeAllUrl }, contex));
};
export default SeeAllSlide;
//# sourceMappingURL=SeeAllSlide.js.map